export default __webpack_public_path__ + "static/media/signpost-3.f783cd8f.png";